import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { NotificationResponse } from '../../types/notification';

interface NotificationsState {
  items: NotificationResponse[];
  isLoading: boolean;
  error?: string | null;
  loaded: boolean;
}

const initialState: NotificationsState = {
  items: [],
  isLoading: false,
  error: null,
  loaded: false,
};

export const notificationsReducer = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    loadNotifications: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    setNotifications: (state, action: PayloadAction<NotificationResponse[]>) => {
      state.items = action.payload;
      state.isLoading = false;
      state.loaded = true;
    },

    addNotification: (state, action: PayloadAction<NotificationResponse>) => {
      const exists = state.items.some((n) => n.id === action.payload.id);
      state.items = exists ? state.items : [action.payload, ...state.items];
    },
    markNotificationsRead: (state, _action: PayloadAction<number[] | undefined>) => {
      state.error = null;
    },
    markNotificationsReadSuccess: (state, action: PayloadAction<number[]>) => {
      const ids = new Set(action.payload);
      const nowIso = new Date().toISOString();
      state.items = state.items.map((n) => (ids.has(n.id) ? { ...n, readAt: nowIso } : n));
    },
  },
});
